module.exports = __webpack_public_path__ + "img/8.13210dba.png";